let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("9XYQ9"), load("6EQss"), load("efZH2")]).then(() => parcelRequire('mS2VM'));